export const formatValueWithRub = (value) => {
  const rawValue = (value || "").toString().trim();
  if (!rawValue) return "";

  if (/\bруб\.?\b/i.test(rawValue)) {
    return rawValue;
  }

  const numberMatch = rawValue.match(/(\d+(?:[.,]\d+)?)/);
  if (!numberMatch) {
    return rawValue;
  }

  return rawValue.replace(numberMatch[1], `${numberMatch[1]} руб`);
};

